import styled from "styled-components";
import { Box, ListItemText, Stack, Typography } from "@mui/material";

export const Title = styled(Typography)`
  && {
    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
    letter-spacing: 0.05em;
    color: #000000;
    margin-bottom: 50px;
  }
`;

export const Process = styled(Typography)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: ${(props) => props.step || "20px"};
    line-height: 30px;
    letter-spacing: 0.05em;
    color: #ffffff;
  }
`;

export const ProcessContainer = styled(Stack)`
  && {
    height: 100px;
    background: linear-gradient(90deg, #3cf0f1 0%, #03424a 100%);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
    border-radius: 15px 0px;
  }
`;

export const KeyPoint = styled(Typography)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 30px;
    letter-spacing: 0.05em;
    color: #000000;
  }
`;

export const Bar = styled(Box)`
  && {
    width: 4px;
    height: 30px;
    background-color: black;
  }
`;

export const StepsText = styled(ListItemText)`
  && {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 30px;
    letter-spacing: 0.05em;
    color: #000000;
  }
`;
